var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title + _vm.typeList[_vm.inputForm.type],
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                size: "small",
                model: _vm.inputForm,
                disabled: _vm.method === "view",
                rules: _vm.dataRule,
                "label-width": "100px",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.doSubmit()
                },
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "菜单类型", prop: "type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.inputForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.inputForm, "type", $$v)
                        },
                        expression: "inputForm.type",
                      },
                    },
                    _vm._l(_vm.typeList, function (type, index) {
                      return _c(
                        "el-radio",
                        { key: index, attrs: { label: index.toString() } },
                        [_vm._v(_vm._s(type))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上级菜单", prop: "parent.id" } },
                [
                  _c("SelectTree", {
                    ref: "menuParentTree",
                    attrs: {
                      props: {
                        value: "id", // ID字段名
                        label: "name", // 显示名称
                        children: "children", // 子级字段名
                      },
                      data: _vm.menuList,
                      value: _vm.inputForm.parent.id,
                      clearable: true,
                      accordion: true,
                    },
                    on: {
                      getValue: function (value) {
                        _vm.inputForm.parent.id = value
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.typeList[_vm.inputForm.type] + "名称",
                    prop: "name",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "50",
                      placeholder: _vm.typeList[_vm.inputForm.type] + "名称",
                    },
                    model: {
                      value: _vm.inputForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.inputForm, "name", $$v)
                      },
                      expression: "inputForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm.inputForm.type === "1" ||
              _vm.inputForm.type === "2" ||
              _vm.inputForm.type === "3"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "链接地址", prop: "href" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "1000",
                          placeholder: "请填写路由路径或者超链接",
                        },
                        model: {
                          value: _vm.inputForm.href,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "href", $$v)
                          },
                          expression: "inputForm.href",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.inputForm.type === "1" ||
              _vm.inputForm.type === "2" ||
              _vm.inputForm.type === "3"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "链接类型", prop: "target" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder:
                              "如果是路由路径请留空白，http链接或者外部链接请选择iframe",
                            clearable: "",
                          },
                          model: {
                            value: _vm.inputForm.target,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "target", $$v)
                            },
                            expression: "inputForm.target",
                          },
                        },
                        _vm._l(
                          [{ label: "iframe", value: "iframe" }],
                          function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.inputForm.type !== "2" && _vm.inputForm.type !== "3"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "菜单图标", prop: "icon" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "菜单图标名称" },
                        on: { focus: _vm.selectIcon },
                        model: {
                          value: _vm.inputForm.icon,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "icon", $$v)
                          },
                          expression: "inputForm.icon",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.inputForm.type !== "2" && _vm.inputForm.type !== "3"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "可见", prop: "isShow" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.inputForm.isShow,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "isShow", $$v)
                            },
                            expression: "inputForm.isShow",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("show_hide"),
                          function (item) {
                            return _c(
                              "el-radio",
                              { key: item.id, attrs: { label: item.value } },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.inputForm.type == "1"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "固定在标签栏", prop: "affix" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.inputForm.affix,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "affix", $$v)
                            },
                            expression: "inputForm.affix",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.inputForm.type !== "0" && _vm.inputForm.type !== "3"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "授权标识", prop: "permission" } },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "50",
                          placeholder:
                            "多个用逗号分隔, 如: user:list,user:create",
                        },
                        model: {
                          value: _vm.inputForm.permission,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "permission", $$v)
                          },
                          expression: "inputForm.permission",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "排序号", prop: "sort" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      step: 30,
                      "controls-position": "right",
                      min: 0,
                      label: "排序号",
                    },
                    model: {
                      value: _vm.inputForm.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.inputForm, "sort", $$v)
                      },
                      expression: "inputForm.sort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remarks" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "200",
                      type: "textarea",
                      rows: 2,
                      placeholder: "备注",
                    },
                    model: {
                      value: _vm.inputForm.remarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.inputForm, "remarks", $$v)
                      },
                      expression: "inputForm.remarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("Icon", {
        ref: "icon",
        on: {
          getValue: function (value) {
            return (_vm.inputForm.icon = value)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }